import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiServiceService } from '../app/api-service.service';

@Injectable()
export class HttpTokenInterceptorService implements HttpInterceptor {
  constructor(
    private apiMicroservice: ApiServiceService,
    private router: Router
  ) {}

  isLoggedIn() {
    return !!sessionStorage.getItem('token');
  }

  redirect(to: string): void {
    this.router.navigate(['/', to]);
  }

  loginExpiredNotifier(): void {
    this.apiMicroservice.openSnackbar(
      'Your login session expired. Please re-login to continue'
    );
  }

  intercept<T>(
    req: HttpRequest<T>,
    next: HttpHandler
  ): Observable<HttpEvent<T>> {
    const allowedRoutes = ['/login', '/forgotpassword']; // Public routes

    // Check if request URL is in allowed routes
    if (allowedRoutes.some((route) => req.url.includes(route))) {
      return next.handle(req); // Allow request without token
    }

    const token = this.apiMicroservice.decryptData(
      sessionStorage.getItem('token')
    );

    if (!token) {
      this.redirectToLogin();
      return EMPTY; // Stop the API request
    }

    // Decode the token to check expiry
    const decodedToken = this.decodeToken(token);
    if (decodedToken && this.isTokenExpired(decodedToken.exp)) {
      console.info('Token expired! Redirecting to login...');
      sessionStorage.clear();
      this.loginExpiredNotifier();
      this.redirect('login');
      this.redirectToLogin();
      return EMPTY; // Stop the API request
    }

    const authReq = req.clone({ headers: req.headers.set('token', token) });
    return next.handle(authReq).pipe(
      catchError((error) => {
        if (error.status === 403 || error.status === 401) {
          sessionStorage.clear();
          this.loginExpiredNotifier();
          this.redirectToLogin();
          return EMPTY; // Stop further requests
        }
        return throwError(() => error);
      })
    );
  }
  // Decode JWT token
  decodeToken(token: string) {
    try {
      return JSON.parse(atob(token.split('.')[1]));
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  // Check if token is expired
  isTokenExpired(exp: number): boolean {
    const now = Math.floor(new Date().getTime() / 1000); // Current timestamp in seconds
    return exp < now;
  }

  // Redirect user to login page
  redirectToLogin(): void {
    this.router.navigate(['/login']);
  }
}
